import { render, staticRenderFns } from "./user_counts.vue?vue&type=template&id=1c2b2e8a"
import script from "./user_counts.vue?vue&type=script&lang=js"
export * from "./user_counts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports